/**
 * Alpine.js wrapper component for creating a tabbed content section with Swiper.
 * Features include:
 * - Managing the selected tab index.
 * - Configuring Swiper for tab navigation.
 * - Building the Swiper instance.
 * - returns object containing methods and properties for managing the tabbed content section.
 */

const tabbedContentSection = () => ({
  selectedIdx: 0,

  get swiperTabsConfig() {
    return {
      slidesPerView: 'auto',
      freeMode: {
        momentum: false,
      },
      on: {
        ppClick: (_, event) => {
          event.target.dispatchEvent(new CustomEvent('swiper-tap', { bubbles: true }));
        },
        init: this.swiperCenterOnNoScroll,
        resize: this.swiperCenterOnNoScroll,
      },
    };
  },

  buildSwiper() {
    this.swiperTabsInstance = new Swiper(this.$el.querySelector('.swiper[swiper-tab-bank]'), this.swiperTabsConfig);
  },

  async init() {
    this.buildSwiper();
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('tabbedContentSection', tabbedContentSection);
});
